<script setup lang="ts">
const { isImpersonating, session } = useAuth()
const { data: workspace } = await useWorkspaceSettings()
</script>
<template>
  <div
    class="relative isolate flex min-h-svh w-full bg-zinc-100 max-lg:flex-col"
  >
    <MissingPaymentBadge v-if="workspace?.missing_payment" />
    <DemoBadge v-else-if="workspace?.demo" />
    <main
      id="main-content"
      class="flex flex-1 flex-col lg:min-w-0 lg:p-2 lg:transition-all lg:duration-200 lg:ease-in-out"
    >
      <div
        class="relative z-10 grow overflow-hidden rounded-lg bg-zinc-50 shadow-xs ring-1 ring-zinc-950/5"
      >
        <div class="@container/main mx-auto h-full w-full">
          <NuxtPage />
        </div>
      </div>
    </main>
    <NotificationToast />
    <ImpersonatingBadge
      v-if="session && isImpersonating"
      :email="session.user.email"
    />
    <DeveloperToolbox />
  </div>
</template>
